import { Button as MuiButton, ButtonProps } from "@mui/material";

// Internal import
import "./MGButton.scss";

export const MGButton = ({
  className,
  variant = "contained",
  children,
  disabled = false,
  ...rest
}: ButtonProps) => {
  return (
    <MuiButton
      variant={variant}
      className={`button-container ${className ? className : ""}`}
      disabled={disabled}
      {...rest}
    >
      {children}
    </MuiButton>
  );
};
